/**
 * Phase 9 (Phase 20: per layer) — the auto-send writes: a campaign group's
 * (or a container's own) switch + settings (one PUT, partial), the country's
 * technical limit, Resume after the country's technical halt (with the
 * person's answer when a send is stuck) and after a layer's stop-loss halt.
 * All refresh every Drop Generator query — the header, Live, the editor and
 * the scheduler status read the same facts.
 * For Media Devoted | Created By Ciro Autiero
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/services/api';

import { dropGeneratorKeys } from '../../../useDropGenerator';

export interface AutoSendPatch {
  dispatchMode?: 'DUE_TIME' | 'SCHEDULE_AHEAD';
  enabled?: boolean;
  /** Phase 29 — shadow mode while on: decides like a send, sends nothing. */
  shadow?: boolean;
  dailySmsCap?: number | null;
  stopLossJson?: unknown;
  stopLossEnabled?: boolean;
  stopLossMinSampleSent?: number;
  stopLossDelayMin?: number;
  /** Containers only: keep an own layer on top of the group's. */
  own?: boolean;
}

export type StuckOutcome = 'sent' | 'not_sent';

export function useAutoSendMutations(countryKey: string) {
  const queryClient = useQueryClient();
  // Refresh in the background: awaiting every Drop Generator query (the day
  // preview among them) would keep Save spinning for seconds after a 20 ms write.
  const invalidate = () => {
    void queryClient.invalidateQueries({ queryKey: dropGeneratorKeys.all });
  };
  const update = useMutation({
    mutationFn: ({ id, patch }: { id: string; patch: AutoSendPatch }) => api.put(`/drop-generator/containers/${id}/autosend`, patch),
    onSuccess: invalidate,
  });
  const country = useMutation({
    mutationFn: (patch: { maxSendFailures: number }) => api.patch(`/drop-generator/plans/${countryKey}/autosend`, patch),
    onSuccess: invalidate,
  });
  const resumeLayer = useMutation({
    mutationFn: (id: string) => api.post(`/drop-generator/containers/${id}/autosend/resume`, {}),
    onSuccess: invalidate,
  });
  const resume = useMutation({
    mutationFn: (stuckOutcome?: StuckOutcome) =>
      api.post(`/drop-generator/plans/${countryKey}/autosend/resume`, stuckOutcome ? { stuckOutcome } : {}),
    onSuccess: invalidate,
  });
  return { update, country, resume, resumeLayer };
}
